module.exports = __webpack_public_path__ + "static/img/20150901-20160122.5519f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20150901-20160122.png
// module id = MfvU
// module chunks = 1